module.exports = __webpack_public_path__ + "5abb4bf3c9d4db7ab7f9acaf74c77816.fbx";